export const API_URL = '/api/validation-workflows/';
export const WF_BASE_QUERYKEY = 'submissions-workflows';
